import { Authorization, Feature } from '@/types/generated/graphql'

/**
 * 認可を行うクラス。
 */
export class Authorizations {
  /**
   * 認可情報。
   */
  readonly authorizations: Array<Authorization>
  constructor(authorizations: Array<Authorization> = []) {
    this.authorizations = authorizations
  }

  /**
   * 指定のfeatureが認可されているならばtrueを返します。
   * @param feature
   */
  public allowed(feature: Feature | undefined): boolean {
    // featureが指定されない場合はOKとみなす
    if (!feature) {
      return true
    }

    if (!this.authorizations) {
      return false
    }

    const authorization = this.authorizations.find(
      (authorization) => authorization.feature === feature
    )

    if (!authorization) {
      return false
    }

    return authorization.allowed
  }
}
